import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {TransformerInterface} from "./transformerInterface";
import {CommandDTO} from "../domain/dtos/command.dto";
import {ReorderLinkTileCommand, ReorderLinkTilePayload} from "../commands/reorder-link-tile.command";

/**
 * Serialises a ReorderLinkTileCommand into the backend command DTO.
 *
 * A dedicated transformer is REQUIRED, not a nicety. Without one the generic
 * command→DTO fallback runs, and that fallback demands a change-tracked proxy
 * as the payload — these commands carry a plain object, so it throws
 * "The payload of the command must be a proxified object". The throw happens
 * OUTSIDE the CommandBus's try block, which wedges the bus for the rest of the
 * session rather than failing the one command.
 *
 * The full envelope is emitted, not just the payload: inside a bulk each
 * sub-command is re-built through the command factory on the server, so every
 * element needs `name`, `uid`, `mainEntityClass` and `mainEntityUid` exactly
 * like an outer command.
 */
@injectable()
@transformer({
    source: ReorderLinkTileCommand,
    target: `dto`
})
export class ReorderLinkTileCommandToDtoTransformer implements TransformerInterface<CommandDTO<ReorderLinkTilePayload>, ReorderLinkTileCommand> {

    public async transform(command: ReorderLinkTileCommand): Promise<CommandDTO<ReorderLinkTilePayload>> {
        return <CommandDTO<ReorderLinkTilePayload>>{
            uid: command.uid,
            name: command.name,
            mainEntityClass: command.mainEntityClass,
            mainEntityUid: command.mainEntityUid,
            payload: command.payload,
        };
    }
}
